import React from 'react';
import {Table} from "antd";
import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";
import UserDiscipline from "../../../models/UserDiscipline";
import InfoTooltip from "../../../components/InfoTooltip";
import UserImageCircle from "../../../components/UserImageCircle";

const TeamDisciplinesTable = (props) => {

    const {
        team,
        project,
        isLoading,
        onEditTeamAssignment,
        removeDisciplineAssignmentForTeamMember,
        isDisabled,
        confirmTeamScope
    } = useTeamCandidateScope();

    const disciplines = TB.orderBy(team?.disciplines || [], [dis => dis.active_hours > 0, dis => !!dis.talent_opp, 'id'], ['desc','desc','asc'])
    if (isLoading|| !team) {
        return null
    }

    return (
        <div className="flex flex-col items-stretch gap-5">
            <Table
                rowKey="id"
                dataSource={disciplines}
                bordered
                size="middle"
                pagination={false}>

                <Table.Column
                    title="Roles"
                    dataIndex="name"
                    render={(_, record) => {
                        let marketRate = UserDiscipline.rateForDiscipline(record.id, project.percent_markup, true);
                        if (!marketRate) {
                            marketRate = 0;
                        }
                        const estCost = Math.ceil(marketRate) * record.total_hours
                        return (
                            <p className="whitespace-nowrap font-semibold flex flex-row gap-1.5 items-center">
                                <span>
                                    {record.name}
                                </span>
                                {record.active_hours > 0 ? (
                                    <InfoTooltip placement="right" type="dark">
                                        <span className="flex flex-col gap-1 px-2 py-3">
                                            <span className="text-white text-sm whitespace-nowrap">
                                                Original Est. Hours: <span
                                                className="text-danger">{record.total_hours}</span>
                                            </span>
                                            <span className="text-white text-sm whitespace-nowrap">
                                                Original Est. Cost: <span
                                                className="text-danger">{TB.formatCurrency(estCost, false)}</span>
                                            </span>
                                        </span>
                                    </InfoTooltip>
                                ) : (
                                    <InfoTooltip placement="right" type="dark" iconColor={TB.config('color.danger')}>
                                        <span className="flex flex-col gap-1 px-2 py-3">
                                            Role is no longer required for the project scope!
                                        </span>
                                    </InfoTooltip>
                                )}
                            </p>
                        )
                    }
                    }
                />
                <Table.Column
                    title="Assigned Team Member"
                    dataIndex="talent_opp"
                    width={270}
                    render={talent_opp => {
                        if (!talent_opp?.user) {
                            return (
                                <p className="italic text-danger">
                                    Member Not Assigned
                                </p>
                            )
                        }
                        return (
                            <div className="flex flex-row items-center gap-2">
                                <UserImageCircle user={talent_opp?.user} size={36}/>
                                <p className="font-medium text-xs whitespace-nowrap">
                                    {talent_opp?.user.fullName()}
                                </p>
                            </div>
                        )
                    }}
                />
                <Table.Column
                    title="Assigned Hours"
                    dataIndex="total_team_hours"
                    width={150}
                    render={(total_team_hours, record) => (
                        <p>
                            {record.talent_opp ? total_team_hours : '-'}
                        </p>
                    )}
                />
                <Table.Column
                    title="Assigned Hourly Rate"
                    dataIndex="talent_opp"
                    width={170}
                    render={talent_opp => {
                        let rates = [talent_opp?.opp_discipline?.hourly_rate];

                        let avgRate = TB.mean(rates)

                        return (
                            <p className="font-semibold whitespace-nowrap">
                                {talent_opp ? `${TB.formatCurrency(avgRate, false)}/hr` : '-'}
                            </p>
                        )
                    }}
                />
                <Table.Column
                    title="Payout Amount"
                    dataIndex="estimated_team_cost"
                    width={150}
                    render={(estimated_team_cost, record) => (
                        <p className="font-semibold whitespace-nowrap">
                            {record.talent_opp ? TB.formatCurrency(estimated_team_cost, false) : '-'}
                        </p>
                    )}
                />
                <Table.Column
                    title="Actions"
                    dataIndex="operation"
                    width={100}
                    render={(_, record) => {
                        if (record.active_hours === 0) {
                            return (
                                <button className="btn btn-link btn-link-danger" disabled={isDisabled}
                                        onClick={() => removeDisciplineAssignmentForTeamMember(record.id)}>
                                    Remove
                                </button>
                            )
                        }

                        return (
                            <button className="btn btn-link btn-link-primary" disabled={isDisabled}
                                    onClick={() => onEditTeamAssignment(record)}>
                                Edit
                            </button>
                        )
                    }}
                />

            </Table>

            <div className="self-end">
                {!team.hasConfirmedScope() && (
                    <button onClick={() => confirmTeamScope()} disabled={isDisabled} className="btn btn-primary">
                        Confirm Team Scope
                    </button>
                )}
            </div>
        </div>
    );
};

export default TeamDisciplinesTable;